<div class="wrapper">
  <p>{{ 'choose_color' | translate }}</p>
</div>
<div class="container">
  @for (color of colors; track color; let i = $index) {
    <div
      class="oval"
      [ngStyle]="{ background: color }"
      (click)="changeColor(i)"
    ></div>
  }
</div>
